// extracted by mini-css-extract-plugin
var _1 = "ChartLegend-moduledot__ThylY";
var _2 = "ChartLegend-moduleitem__lQYBD";
var _3 = "ChartLegend-modulelegend__Qoxj9";
var _4 = "ChartLegend-modulevalue__w1xJ7";
export { _1 as "dot", _2 as "item", _3 as "legend", _4 as "value" }
